<template>
  <div class="ins-main platform-area">
    <div class="groupHeading header">
      {{ $t("lang_groupHeading_templates") }}
    </div>
    <div class="platformTheme-box">
      <div class="themeSub-area">
        <div class="underLineHeading">
          <span>{{ $t("lang_themeHeading_template") }}</span>
        </div>
        <div class="switchPcMb" style="">
          <router-link to="/platformlobby/pc" class="switchPc">{{ $t("lang_template_type_pc") }}</router-link>
          <router-link to="/platformlobby/mobile" class="switchMb">{{ $t("lang_template_type_mb") }}</router-link>
        </div>
        <div class="slogan themeDesc" v-html="$t('lang_themeHeading_template_narrative')"></div>
      </div>
      <template v-if="!isMobile">
        <ul>
          <li>
            <div
              :class="{ 'allMbTheme-list': $route.params.name === 'mobile', 'allPcTheme-list': $route.params.name === 'pc' }">
              <ul>
                <li v-for="(item, index) in platformData" :key="index">
                  <div class="theme-box">
                    <router-link :to="`/platformShow/${$route.params.name}/${item.id}`" target="_blank"><img
                        :src='fileUrl(`${item.list}`)' alt="" /></router-link>
                    <i class="number-ico"><span v-html="
                      `${index + 1 < 10 ? '0' + (index + 1) : index + 1}`
                    "></span></i>
                    <i class="info-ico">
                      <router-link :to="`/platformShow/${$route.params.name}/${item.id}`" target="_blank"></router-link>
                    </i>
                  </div>
                  <div class="showInfo-box">
                    <div class="themeNo">
                      {{ $t("lang_template_ver")
                      }}{{ (index + 1).toString().padStart(2, '0') }} </div>
                    <div class="demo-list">
                      <span>
                        <router-link :to="`/platformShow/${$route.params.name}/${item.id}`" target="_blank">Info
                        </router-link>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </template>
      <template v-else>
        <div class="carouselOutSide">
          <carousel ref="carousel" :perPage="1" :mouse-drag="false" :navigationEnabled="true" :paginationEnabled="true"
            :navigationNextLabel="`<span class='icon-32'></span>`"
            :navigationPrevLabel="`<span class='icon-32'></span>`" :loop="true" class="platform-slider">
            <slide v-for="(item, index) in platformData" :key="index">
              <div class="theme-box">
                <router-link :to="`/platformShow/${$route.params.name}/${item.id}`" target="_blank"><img :src='fileUrl(`${item.list}`)'
                    alt="" /></router-link>
                <i class="info-ico">
                  <router-link :to="`/platformShow/${$route.params.name}/${item.id}`" target="_blank"></router-link>
                </i>
              </div>
              <div class="showInfo-box">
                <div class="themeNo">
                  {{ $t("lang_template_ver")
                  }}{{ (index + 1).toString().padStart(2, '0') }} </div>
                <div class="demo-list">
                  <span>
                    <router-link :to="`/platformShow/${$route.params.name}/${item.id}`" target="_blank">Info</router-link>
                  </span>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import { BACKEND_LOCATION } from '@api/Endpoints'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: "Platformlobby",
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      platformData: [],
      pcPlatformData: [],
      mobilePlatformData: [],
      isMobile: false,
      deviceModel: "pc",
    };
  },
  computed: {
    ...mapGetters({
      defLangx: 'defLangx',
      nowLangx: 'nowLangx',
    }),
  },
  methods: {
    getDevice: function () {
      const $this = this;
      window.addEventListener("resize", $this.windowRes);
      this.windowRes();
    },
    windowRes: function () {
      const $this = this;
      if ($this.deviceModel === "mb" && document.body.clientWidth > 996) {
        $this.isMobile = false;
        $this.deviceModel = "pc";
      } else if (
        $this.deviceModel === "pc" &&
        document.body.clientWidth <= 996
      ) {
        $this.isMobile = true;
        $this.deviceModel = "mb";
      }
    },
    fileUrl(url) {
      const img = url !== 'undefined' && url !== '' ? BACKEND_LOCATION.file + url : false
      return img
    },
    async getPlatformData() {
      try {
        const api = BACKEND_LOCATION.api + 'getdata/platform/' + this.nowLangx
        const res = await axios.post(api)

        if (res.data.code !== '100') {
          throw new Error("Can not get data from getPlatformData function")
        }
        this.pcPlatformData = res.data.info.filter(item => item.device === 'pc').sort((a, b) => a.sort - b.sort)
        this.mobilePlatformData = res.data.info.filter(item => item.device === 'mobile').sort((a, b) => a.sort - b.sort)
        this.fetchPlatformData()
      }
      catch (error) {
        console.error(error);
      };
    },
    fetchPlatformData() {
      if (this.$route.params.name === 'pc') {
        this.platformData = this.pcPlatformData
      } else if (this.$route.params.name === 'mobile') {
        this.platformData = this.mobilePlatformData
      }
    }
  },
  mounted() {
    this.getPlatformData()
    this.fetchPlatformData()
    this.getDevice();
    this.$store.dispatch("setLoadshow", false);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.windowRes);
    this.$store.dispatch("setLoadshow", true);
  },
  beforeRouteUpdate(to, from, next) {
    next()
    this.fetchPlatformData()
  }
};
</script>
<style lang="sass">
@import '@css/platformlobby.sass'
</style>